






import { Vue, Component } from 'vue-property-decorator'
import { preloadConfig } from './store/config';

@Component
export default class App extends Vue {
  async created() {
    await preloadConfig()
  }
}
